<template>
  <v-container fluid >
    <v-toolbar color="#FAFAFA" flat>
      <!--v-toolbar-side-icon @click="$emit('showHideMenu')"></v-toolbar-side-icon-->
      <v-toolbar-title >Obras</v-toolbar-title>
      <v-spacer></v-spacer>
      <!--v-btn color="success" light to="/obras/adicionar">Adicionar</v-btn-->
      <v-btn light  color="primary" flat to="/obras/adicionar"><v-icon left>add</v-icon>Adicionar</v-btn>
    </v-toolbar>
  <v-divider></v-divider>
    <v-card flat>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Busca" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="works"
        :search="search"
        no-data-text="Nenhuma obra encontrada."
        no-results-tex="Nenhuma obra encontrada."
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.iswc }}</td>          
          <td>{{ props.item.public_domain ? "SIM": "NÃO" }}</td>
          
          <td class="text-xs-right">
            <v-menu offset-x left bottom>
              <v-btn icon slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile  :to="{name:'obras_editar', params:{ id:props.item.id} }">
                  <v-list-tile-title>Editar</v-list-tile-title>
                </v-list-tile>                
              </v-list>
            </v-menu>
          </td>
        </template>

        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >A sua busca por "{{ search }}" não teve resultados.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import WorkService from "../app/Rest/work";

const workService = WorkService.build();

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Titulo", align:"left", sortable: true, value: "name" },       
        { text: "ISWC", align:"left", sortable: true, value: "iswc" },       
        { text: "Dominío Público", align:"left", sortable: true, value: "name" },       
        { text: "Ações", align: "right", value: "iron" }
      ],
      works: []
    }
  },
  methods: {
    //trocado pelo Vuex
  },
  mounted() {
    //this.fetchRecords();
    this.works = this.$store.getters.obras;
  }
};
</script>